import { Component, OnInit, ViewChild, Inject, ViewChildren, QueryList } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogRef, MAT_DIALOG_DATA, DateAdapter } from '@angular/material';
import { IndicatorService } from '../services/indicator.service';
import { ActionsService } from '../services/actions.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MethodService } from '../services/method.service';
import { MachineService } from '../services/machine.service';
import { ProductService } from '../services/product.service';
import { ModalsComponent } from '../modals/modals.component';
import { MachineInsertComponent } from '../machine-insert/machine-insert.component';
import { IndicatorInsertComponent } from '../indicator-insert/indicator-insert.component';
import { ProductInsertComponent } from '../product-insert/product-insert.component';
import { MethodInsertComponent } from '../method-insert/method-insert.component';
import { PackageService } from '../services/package.service';
import { PackageInsertComponent } from '../package-insert/package-insert.component';
import { ServiceService } from '../services/service.service';
import { Subject } from '../subject/subject.component';
import { SubjectService } from '../services/subject.service';
import { SubjectInsertComponent } from '../subject-insert/subject-insert.component';
import { Location } from '@angular/common';

export interface Indicator {
  id: number;
  name: string;
  price: string;
  method: string;
  machine: string;
  unit: string;
  abbreviation: string;
}

export interface Machine {
  id: number;
  name: string;
  last_check: string;
}

export interface Product {
  id: number;
  name: string;
  parent_id: number;
}

export interface Method {
  id: number;
  name: string;
}

export interface Package {
  id: number;
  name: string;
  price: string;
  selIndicators: any;
  indicatorIds:any;
  packageProds: any;
  product_id: number;
}

export interface Service {
  id: number;
  name: string;
  item_number: string;
}


@Component({
  selector: 'app-system-data',
  templateUrl: './system-data.component.html',
  styleUrls: ['./system-data.component.css']
})
export class SystemDataComponent implements OnInit {
  //indicator Properties
  indicator_id: number;
  indicators: any;
  abbreviation: string;
  watchIndicator:boolean;
  ref_value:string;
  addIndicator: boolean;
  editIndicator: boolean;
  deleteIndicator: boolean;
  columns: any;
  columnsToDisplay: any;
  displayedColumns: any;
  dataSource: MatTableDataSource<Indicator>;
  selection: any;
  name: string;
  name_en: string;
  name_ru:string;
  accreditation:string;
  item_number: number;
  price: string;
  unit: string;
  machine_id: number;
  method_id: number;
  methods: any;
  selections: any;
  machines: any;
  products: any;
  selectedProds: any;

  //machine Properties
  watchMachine:boolean;
  addMachine: boolean;
  editMachine: boolean;
  deleteMachine: boolean;
  machineColumnsToDisplay: any;
  machineDisplayedColumns: any;
  machineDataSource: MatTableDataSource<Machine>;
  machineSelection: any;

  //product properties
  parent_id: number = 0;
  watchProduct:boolean;
  addProduct: boolean;
  editProduct: boolean;
  deleteProduct: boolean;
  productColumnsToDisplay: any;
  productDisplayedColumns: any;
  productDataSource: MatTableDataSource<Product>;
  productSelection: any;

  //methods properties
  watchMethod:boolean;
  addMethod: boolean;
  editMethod: boolean;
  deleteMethod: boolean;
  methodColumnsToDisplay: any;
  methodDisplayedColumns: any;
  methodDataSource: MatTableDataSource<Method>;
  methodSelection: any;

  //package properties
  packages: any;
  watchPackage:boolean;
  addPackage: boolean;
  editPackage: boolean;
  deletePackage: boolean;
  packageProds: any;
  packageColumnsToDisplay: any;
  packageDisplayedColumns: any;
  packageDataSource: MatTableDataSource<Package>;
  packageSelection: any;


  //service properties
  services: any;
  watchService:boolean;
  addService: boolean;
  editService: boolean;
  deleteService: boolean;
  serviceColumnsToDisplay: any;
  serviceDisplayedColumns: any;
  serviceDataSource: MatTableDataSource<Service>;
  serviceSelection: any;

  //subject properties;
  subjects:any;
  watchSubject:boolean;
  addSubject: boolean;
  editSubject: boolean;
  deleteSubject: boolean;
  subjectColumnsToDisplay: any;
  subjectDisplayedColumns: any;
  subjectSelection: any;
  subjectDataSource: MatTableDataSource<Subject>;

  //filter
  productFilter:any;
  indicatorName:string;
  isAccredited:boolean;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  constructor(private indicatorService: IndicatorService,
    private methodService: MethodService,
    private machineService: MachineService,
    private productService: ProductService,
    private serviceService: ServiceService,
    private packageService: PackageService,
    private subjectService:SubjectService,
    private actionService: ActionsService,
    private dateAdapter: DateAdapter<Date>,
    private _location:Location,
    public dialog: MatDialog) {
    
    this.getIndicatorActions();
    this.getProductActions();
    this.getMachineActions();
    this.getMethodActions();
    this.getServiceActions();
    this.getPackageActions();
    this.getSubjectActions();
    this.getSubjects();
    this.getServices();
    this.getMethods();
    this.getMachines();
    
    this.getPackages();
    this.getIndicators();
    this.parent_id = 0;
    dateAdapter.setLocale('en-in');
  }


  ngOnInit() {
    this.getProducts();
  }


  filterIndicators(){
    var data = {
      product:this.productFilter,
      indicator:this.indicatorName,
      accredited:this.isAccredited
    };
    this.indicatorService.filterIndicator(data).subscribe(resp => {
      if(resp){
        this.indicators = resp
        this.displayedColumns = ['id', 'name', 'price', 'machine', 'method', 'actions'];
        this.columnsToDisplay = this.displayedColumns.slice();
        this.dataSource = new MatTableDataSource<Indicator>(resp);
        this.selection = new SelectionModel<Indicator>(true, []);
        this.dataSource.sort = this.sort.toArray()[0];
        this.dataSource.paginator = this.paginator.toArray()[0];
      
      }
    });

  }


  //delete
  deleteModal(id, component): void {
    const dialogRef = this.dialog.open(ModalsComponent, {
      width: '250px',
      data: { id: id, component: component }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'indicator') {
        this.getIndicators();
        this.getPackages();
      } else if (result == 'machine') {
        this.getMachines();
      } else if (result == 'product') {
        if (this.parent_id == 0) {
          this.getProducts();
        } else {
          this.subProducts(this.parent_id);
        }
      } else if (result == 'method') {
        this.getMethods();
      } else if (result == 'package') {
        this.getPackages();
      } else if (result == 'service') {
        this.getServices();
      } else if (result == 'subject') {
        this.getSubjects();
      }

    });
  }


  //Indicators
  openDialog(id): void {
    if (id != 0) {
      this.indicatorService.editIndicator(id).subscribe(data => {
        this.name = data.name,
          this.item_number = data.item_number,
          this.price = data.price,
          this.unit = data.unit,
          this.method_id = data.method_id,
          this.abbreviation = data.abbreviation,
          this.machine_id = data.machine_id,
          this.ref_value = data.ref_value,
          this.name_en = data.name_en,
          this.name_ru = data.name_ru,
          this.accreditation = data.accreditation
          //foreach machines to get the names
          this.selectedProds = Object.keys(data.selectedValues).map(i => data.selectedValues[i])
        const dialogRef = this.dialog.open(IndicatorInsertComponent, {
          width: '600px',
          data: {
            methods: this.methods,
            machines: this.machines,
            products: this.products,
            ref_value:this.ref_value,
            abbreviation: this.abbreviation,
            indicator_id: id,
            item_number: this.item_number,
            name: this.name,
            method_id: this.method_id,
            machine_id: this.machine_id,
            selectedProds: this.selectedProds,
            name_en:this.name_en,
            name_ru:this.name_ru,
            price: this.price,
            unit: this.unit,
            indicators:this.indicators,
            parent_id:data.parent_id,
            accreditation :this.accreditation 
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result != undefined) {
            this.indicatorService.updateIndicator(result, id).subscribe(data => {
              this.getIndicators();
            });
          }
        });
      });
    } else {
      const dialogRef = this.dialog.open(IndicatorInsertComponent, {
        width: '600px',
        data: { methods: this.methods,indicators:this.indicators, machines: this.machines, abbreviation: this.abbreviation, products: this.products, indicator_id: id }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.indicatorService.saveIndicator(result).subscribe(data => {
            this.getIndicators();
          });
        }
      });
    }
  }


  getIndicatorActions() {
    this.actionService.moduleAction(5).subscribe(data => {
      this.watchIndicator = data.watch_action;
      this.addIndicator = data.add_action;
      this.editIndicator = data.edit_action;
      this.deleteIndicator = data.delete_action;

    });
  }

  getIndicators() {
    this.indicatorService.getIndicators().subscribe(data => {
      this.indicators = data
      // console.log(data);
      this.displayedColumns = ['id', 'name', 'price', 'machine', 'method', 'actions'];
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Indicator>(data);
      console.log(this.dataSource,data);
      this.selection = new SelectionModel<Indicator>(true, []);
      this.dataSource.sort = this.sort.toArray()[0];
      this.dataSource.paginator = this.paginator.toArray()[0];
      
    });

    return this.indicators;
  }

  editIndicatorFunc(id) {
    this.indicatorService.editIndicator(id).subscribe(data => {
      this.name = data.name,
        this.item_number = data.item_number,
        this.price = data.price,
        this.unit = data.unit,
        this.method_id = data.method_id,
        this.machine_id = data.machine_id,
        this.selectedProds = Object.keys(data.selectedValues).map(i => data.selectedValues[i])
    });
  }

  getMethods() {
    this.methodService.getMethods().subscribe(data => {
      console.log(data);
      this.methods = data
      this.methodDisplayedColumns = ['id', 'name', 'actions'];
      this.methodColumnsToDisplay = this.methodDisplayedColumns.slice();
      this.methodDataSource = new MatTableDataSource<Method>(this.methods);
      this.methodSelection = new SelectionModel<Method>(true, []);
      this.methodDataSource.sort = this.sort.toArray()[1];
      this.methodDataSource.paginator = this.paginator.toArray()[1];
    });
    return this.methods;
  }


  getMachines() {
    this.machineService.getMachines().subscribe(data => {
      this.machines = data
      this.machineDisplayedColumns = ['id', 'name', 'last_check', 'actions'];
      this.machineColumnsToDisplay = this.machineDisplayedColumns.slice();
      this.machineDataSource = new MatTableDataSource<Machine>(this.machines);
      this.machineSelection = new SelectionModel<Machine>(true, []);
      this.machineDataSource.sort = this.sort.toArray()[2];
      this.machineDataSource.paginator = this.paginator.toArray()[2];
    });

    return this.machines;
  }

  getServices() {
    this.serviceService.getServices().subscribe(data => {
      this.services = data
      this.serviceDisplayedColumns = ['id', 'name', 'item_number', 'actions'];
      this.serviceColumnsToDisplay = this.serviceDisplayedColumns.slice();
      this.serviceDataSource = new MatTableDataSource<Service>(this.services);
      this.serviceSelection = new SelectionModel<Service>(true, []);
      this.serviceDataSource.sort = this.sort.toArray()[5];
      this.serviceDataSource.paginator = this.paginator.toArray()[5];
    });

    return this.services;
  }

  getServiceActions() {
    this.actionService.moduleAction(15).subscribe(data => {
      this.watchService = data.watch_action;
      this.addService = data.add_action;
      this.editService = data.edit_action;
      this.deleteService = data.delete_action;
    });
  }

  openServiceDialog(id): void {
    if (id != 0) {
      this.serviceService.editService(id).subscribe(data1 => {
        const dialogRef = this.dialog.open(Service, {
          width: '600px',
          data: {
            name: data1.name,
            item_number: data1.item_number,
            price: data1.price,
          }
        });

        dialogRef.afterClosed().subscribe(result => {

          if (result != undefined) {
            this.serviceService.updateService(result, id).subscribe(data => {
              this.getServices();
            });
          }
        });
      });
    } else {
      const dialogRef = this.dialog.open(Service, {
        width: '600px',
        data: {
          name: '',
          item_number: '',
          price: ''
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        if (result != undefined) {
          this.serviceService.saveService(result).subscribe(data => {
            this.getServices();
          });
        }
      });
    }
  }

  getProducts() {
    this.productService.getAllProducts().subscribe(data => {
      this.products = Object.keys(data).map(i => data[i]);
      console.log(this.products);
      this.productDisplayedColumns = ['id', 'name', 'actions'];
      this.productColumnsToDisplay = this.productDisplayedColumns.slice();
      this.productDataSource = new MatTableDataSource<Product>(this.products);
      this.productSelection = new SelectionModel<Product>(true, []);
      this.productDataSource.sort = this.sort.toArray()[3];
      this.productDataSource.paginator = this.paginator.toArray()[3];
    });
    return this.products;
  }


  //machines
  getMachineActions() {
    this.actionService.moduleAction(3).subscribe(data => {
      this.watchMachine = data.watch_action;
      this.addMachine = data.add_action;
      this.editMachine = data.edit_action;
      this.deleteMachine = data.delete_action;

    });
  }

  openMachineDialog(id): void {
    console.log(id);
    if (id != 0) {
      this.machineService.editMachine(id).subscribe(data1 => {
        const dialogRef = this.dialog.open(MachineInsertComponent, {
          width: '600px',
          data: {
            name: data1.name,
            name_en:data1.name_en,
            name_ru:data1.name_ru,
            number: data1.number,
            description: data1.description,
            method_number: data1.method_number,
            last_check: new Date(data1.last_check),
          }
        });

        dialogRef.afterClosed().subscribe(result => {

          if (result != undefined) {
            console.log(result);
            var lastCheck = result.last_check;
            if(lastCheck){
              lastCheck = lastCheck.toLocaleDateString('en-GB');
            }
            var data = {
              name: result.name,
              name_en:result.name_en,
              name_ru:result.name_ru,
              number: result.number,
              method_number: result.method_number,
              description: result.description,
              last_check: lastCheck
            }
            this.machineService.updateMachine(data, id).subscribe(data => {
              this.getMachines();
            });
          }
        });
      });
    } else {
      const dialogRef = this.dialog.open(MachineInsertComponent, {
        width: '600px',
        data: {
          name: '',
          number: '',
          description: '',
          method_number: '',
          last_check: new Date(),
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          console.log(result);
          var lastCheck = result.last_check;
          if(lastCheck){
            lastCheck = lastCheck.toLocaleDateString('en-GB');
          }
          var data = {
            name: result.name,
            name_en:result.name_en,
            name_ru:result.name_ru,
            number: result.number,
            method_number: result.method_number,
            description: result.description,
            last_check: lastCheck
          }
          this.machineService.saveMachine(data).subscribe(data => {
            this.getMachines();
          });
        }
      });
    }
  }

  //products 

  getProductActions() {
    this.actionService.moduleAction(6).subscribe(data => {
      this.watchProduct = data.watch_action;
      this.addProduct = data.add_action;
      this.editProduct = data.edit_action;
      this.deleteProduct = data.delete_action;
    });
  }

  subProducts(parent_id) {

    this.productService.getSubProducts(parent_id).subscribe(data => {
      if (data[0] != undefined) {
        this.parent_id = data[0].parent_id;
      } else {
        this.parent_id = parent_id;
      }
      this.products = Object.keys(data).map(i => data[i]);
      this.productDisplayedColumns = ['id', 'name', 'actions'];
      this.productColumnsToDisplay = this.productDisplayedColumns.slice();
      this.productDataSource = new MatTableDataSource<Product>(this.products);
      this.productSelection = new SelectionModel<Product>(true, []);
      this.productDataSource.sort = this.sort.toArray()[2];
      this.productDataSource.paginator = this.paginator.toArray()[2];

    });
    return this.products;
  }

  backToParent() {
    if (this.parent_id != 0) {
      this.productService.getParentProds(this.parent_id).subscribe(data => {
        this.products = Object.keys(data).map(i => data[i]);
        this.parent_id = data[0].parent_id;
        this.productDisplayedColumns = ['id', 'name', 'actions'];
        this.productColumnsToDisplay = this.productDisplayedColumns.slice();
        this.productDataSource = new MatTableDataSource<Product>(this.products);
        this.productSelection = new SelectionModel<Product>(true, []);
        this.productDataSource.sort = this.sort.toArray()[2];
        this.productDataSource.paginator = this.paginator.toArray()[2];
      });
    }
  }


  openProductDialog(id): void {
    if (id != 0) {
      this.productService.editProduct(id).subscribe(data1 => {
        const dialogRef = this.dialog.open(ProductInsertComponent, {
          width: '600px',
          data: {
            name: data1.name,
            name_en:data1.name_en,
            name_ru:data1.name_ru,
            parent_id: data1.parent_id,
          }
        });

        dialogRef.afterClosed().subscribe(result => {

          if (result != undefined) {
            this.productService.updateProduct(result, id).subscribe(data => {
              if (this.parent_id == 0) {
                this.getProducts();
              } else {
                this.subProducts(this.parent_id);
              }
            });
          }
        });
      });
    } else {
      const dialogRef = this.dialog.open(ProductInsertComponent, {
        width: '600px',
        data: {
          name: '',
          parent_id: this.parent_id,
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.productService.saveProduct(result).subscribe(data => {
            if (this.parent_id == 0) {
              this.getProducts();
            } else {
              this.subProducts(this.parent_id);
            }
          });
        }
      });
    }
  }


  //methods
  getMethodActions() {
    this.actionService.moduleAction(4).subscribe(data => {
      this.watchMethod = data.watch_action;
      this.addMethod = data.add_action;
      this.editMethod = data.edit_action;
      this.deleteMethod = data.delete_action;
    });
  }

  openMethodDialog(id): void {
    if (id != 0) {
      this.methodService.editMethod(id).subscribe(data1 => {
        const dialogRef = this.dialog.open(MethodInsertComponent, {
          width: '600px',
          data: {
            name: data1.name,
            name_en:data1.name_en,
            name_ru:data1.name_ru
          }
        });

        dialogRef.afterClosed().subscribe(result => {

          if (result != undefined) {
            this.methodService.updateMethod(result, id).subscribe(data => {
              this.getMethods();
            });
          }
        });
      });
    } else {
      const dialogRef = this.dialog.open(MethodInsertComponent, {
        width: '600px',
        data: {
          name: '',
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.methodService.saveMethod(result).subscribe(data => {
            this.getMethods();
          });
        }
      });
    }
  }

  //packages

  getPackages() {
    this.packageService.getPackages().subscribe(data => {
      this.packages = data
      this.packageDisplayedColumns = ['id', 'name', 'product', 'price', 'actions'];
      this.packageColumnsToDisplay = this.packageDisplayedColumns.slice();
      this.packageDataSource = new MatTableDataSource<Package>(this.packages);
      this.packageSelection = new SelectionModel<Package>(true, []);
      this.packageDataSource.sort = this.sort.toArray()[4];
      this.packageDataSource.paginator = this.paginator.toArray()[4];
    });
    return this.packages;
  }

  getPackageActions() {
    this.actionService.moduleAction(13).subscribe(data => {
      this.watchPackage = data.watch_action;
      this.addPackage = data.add_action;
      this.editPackage = data.edit_action;
      this.deletePackage = data.delete_action;
    });
  }



  openPackageDialog(id): void {
    if (id != 0) {
      this.packageService.editPackage(id).subscribe(data1 => {
        console.log(data1);
        const dialogRef = this.dialog.open(PackageInsertComponent, {
          width: '600px',
          data: {
            name: data1.name,
            packageProds: data1.products,
            products: this.products,
            selIndicators: data1.indicators,
            indicatorIds:data1.indicatorIds,
            price: data1.price,
            package_id: id,
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.getPackages();
        });
      });
    } else {
      const dialogRef = this.dialog.open(PackageInsertComponent, {
        width: '600px',
        data: {
          name: '',
          products: this.products,
          price: '',
          package_id: id,
          selIndicators: [],
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        this.getPackages();
      });
    }
  }


//subjects

  getSubjects() {
    this.subjectService.getSubjects().subscribe(data => {
      this.subjects = data,
      this.subjectDisplayedColumns = ['name', 'eik', 'city', 'actions'];
      this.subjectColumnsToDisplay = this.subjectDisplayedColumns.slice();
      this.subjectDataSource = new MatTableDataSource<Subject>(this.subjects);
      this.subjectSelection = new SelectionModel<Subject>(true, []);
      this.subjectDataSource.sort = this.sort.toArray()[6];
      this.subjectDataSource.paginator = this.paginator.toArray()[6];
    });
  }

  getSubjectActions() {
    this.actionService.moduleAction(7).subscribe(data=>{
      this.watchSubject = data.watch_action;
      this.addSubject = data.add_action;
      this.editSubject = data.edit_action;
      this.deleteSubject = data.delete_action;
      if(!this.watchIndicator && !this.watchMachine && !this.watchMethod && !this.watchPackage && !this.watchProduct && !this.watchService && !this.watchSubject){
        this._location.back();
      }
    });
  }

  openSubjectDialog(id): void {
    if (id != 0) {
      this.subjectService.editSubject(id).subscribe(data1 => {
        const dialogRef = this.dialog.open(SubjectInsertComponent, {
          width: '600px',
          data: data1
        });

        dialogRef.afterClosed().subscribe(result => {
          this.getSubjects();
        });
      });
    } else {
      const dialogRef = this.dialog.open(SubjectInsertComponent, {
        width: '600px',
        data: {}
      });

      dialogRef.afterClosed().subscribe(result => {
        this.getSubjects();
      });
    }
  }
  


}

@Component({
  selector: 'service-insert',
  templateUrl: 'service.html',
})
export class Service {

  constructor(
    public dialogRef: MatDialogRef<Service>,
    @Inject(MAT_DIALOG_DATA) public data: Service) { }

  closeModal(): void {
    this.dialogRef.close();
  }

}